import axios from 'axios';

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/sepeformacion`,
});
API.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// — Áreas
export const getAreas    = (params)   => API.get('/areas', { params });
export const getArea     = (id)       => API.get(`/areas/${id}`);
export const createArea  = (data)     => API.post('/areas', data);
export const updateArea  = (id, data) => API.put(`/areas/${id}`, data);
export const deleteArea  = (id)       => API.delete(`/areas/${id}`);
export const subirImagenArea = (id, file) => {
  const fd = new FormData();
  fd.append('imagen', file);
  // NO fijamos Content-Type: axios pone el boundary de multipart. Igual que cursos.
  return API.post(`/areas/${id}/imagen`, fd);
};
// URL del proxy AUTENTICADO de imagen de área (para el panel, vía useImagenBlob).
export const imagenAreaUrl = (name) =>
  name ? `${process.env.REACT_APP_API_URL}/api/sepeformacion/areas/imagen/${name}` : null;

// — Convocatorias
export const getConvocatorias   = (params)   => API.get('/convocatorias', { params });
export const createConvocatoria = (data)     => API.post('/convocatorias', data);
export const updateConvocatoria = (id, data) => API.put(`/convocatorias/${id}`, data);
export const deleteConvocatoria = (id)       => API.delete(`/convocatorias/${id}`);

// — Cursos
export const getCursos          = (params)            => API.get('/cursos', { params });
export const getCurso           = (id)                => API.get(`/cursos/${id}`);
export const createCurso        = (data)              => API.post('/cursos', data);
export const updateCurso        = (id, data)          => API.put(`/cursos/${id}`, data);
export const deleteCurso        = (id)                => API.delete(`/cursos/${id}`);
export const toggleCursoActivo  = (id, activo)        => API.patch(`/cursos/${id}/activo`, { activo });
export const togglePublicado    = (id, publicado_web) => API.patch(`/cursos/${id}/publicado`, { publicado_web });
// Acciones masivas: { ids, accion, estado?, area_id? } → { aplicados, fallidos }
export const bulkCursos         = (payload)           => API.post('/cursos/bulk', payload);
export const subirImagenCurso = (id, file) => {
  const fd = new FormData();
  fd.append('imagen', file);
  // NO fijamos Content-Type a mano: el browser/axios añade el boundary
  // automáticamente para FormData. Si lo fijamos a 'multipart/form-data'
  // sin boundary, multer en backend no puede parsear y req.file queda undefined.
  return API.post(`/cursos/${id}/imagen`, fd);
};
// URL del proxy de imagen. NO usable con <img src=...> directamente porque el
// browser no manda el Bearer; úsala con el hook useImagenBlob para que la
// descargue con auth y devuelva un ObjectURL.
export const imagenCursoUrl = (name) =>
  name ? `${process.env.REACT_APP_API_URL}/api/sepeformacion/cursos/imagen/${name}` : null;
// — F3: PDF de temario
export const subirTemarioPdf = (id, file) => {
  const fd = new FormData();
  fd.append('pdf', file);
  return API.post(`/cursos/${id}/temario-pdf`, fd);
};
export const borrarTemarioPdf = (id) => API.delete(`/cursos/${id}/temario-pdf`);
// URL PÚBLICA del PDF (se abre en pestaña nueva; el endpoint público no requiere Bearer).
export const temarioPdfUrl = (name) =>
  name ? `${process.env.REACT_APP_API_URL}/api/sepeformacion/public/cursos/temario/${name}` : null;

// — Alumnos potenciales (leads de inscripción pública SEPE)
export const listarAlumnos       = (params)   => API.get('/alumnos-potenciales', { params }).then(r => r.data);
export const obtenerAlumno       = (id)       => API.get(`/alumnos-potenciales/${id}`).then(r => r.data);
export const actualizarAlumno    = (id, data) => API.put(`/alumnos-potenciales/${id}`, data).then(r => r.data);
export const eliminarAlumno      = (id)       => API.delete(`/alumnos-potenciales/${id}`).then(r => r.data);
export const exportarAlumnosXlsx = (params)   => API.get('/alumnos-potenciales/export.xlsx', { params, responseType: 'blob' }).then(r => r.data);

export default API;
